const nord = {
  "bg-color": "#262c3a",
  "bg-secondary-color": "#3b4252",
  "nav-color": "#1f2937",
  "color-primary": "#5e81ac",
  "color-lightGrey": "#3b4252",
  "color-grey": "#5e81ac",
  "color-darkGrey": "#3f4144",
  "color-error": "#bf616a",
  "color-success": "#a3be8c",
  "color-1-min": "#88c0d0",
  "color-6-min": "#a3be8c",
  "color-7-min": "#b48ead",
  "color-7-15-min": "#bf616a",
  "font-color": "#eceff4",
};

const tokyo = {
  "bg-color": "#24283b",
  "bg-secondary-color": "#1a1b26",
  "nav-color": "#1a1b26",
  "color-primary": "#7aa2f7",
  "color-lightGrey": "#414868",
  "color-grey": "#7aa2f7",
  "color-darkGrey": "#414868",
  "color-error": "#f7768e",
  "color-success": "#9ece6a",
  "color-1-min": "#73daca",
  "color-6-min": "#9ece6a",
  "color-7-min": "#ff9e64",
  "color-7-15-min": "#f7768e",
  "font-color": "#c0caf5",
};

const umbra = {
  "bg-color": "#1b1b1b",
  "bg-secondary-color": "#242424",
  "nav-color": "#121212",
  "color-primary": "#b392f0",
  "color-lightGrey": "#515052",
  "color-grey": "#b392f0",
  "color-darkGrey": "#87848b",
  "color-error": "#f25262",
  "color-success": "#5ae6b7",
  "color-1-min": "#b392f0",
  "color-6-min": "#5ae6b7",
  "color-7-min": "#aa8be3",
  "color-7-15-min": "#f25262",
  "font-color": "#fff5f5",
};

const onedark = {
  "bg-color": "#282c33",
  "bg-secondary-color": "#20242c",
  "nav-color": "#1d2024",
  "color-primary": "#55b6c2",
  "color-lightGrey": "#abb2bf",
  "color-grey": "#55b6c2",
  "color-darkGrey": "#55b6c2b",
  "color-error": "#e06b74",
  "color-success": "#98c379",
  "color-1-min": "#62aeef",
  "color-6-min": "#98c379",
  "color-7-min": "#c778dd3",
  "color-7-15-min": "#e06b74",
  "font-color": "#abb2bf",
};

const pastel = {
  "bg-color": "#484D56",
  "bg-secondary-color": "#3D4249",
  "nav-color": "#3D4249",
  "color-primary": "#8FC1E2",
  "color-lightGrey": "#3D4249",
  "color-grey": "#8FC1E2",
  "color-darkGrey": "#AC94C9",
  "color-error": "#ED424",
  "color-success": "#B0D9CD",
  "color-1-min": "#8FC1E2",
  "color-6-min": "#B0D9CD",
  "color-7-min": "#6B8790",
  "color-7-15-min": "#ED424",
  "font-color": "#FFFFFF",
};

const spotify = {
  "bg-color": "#121212",

  "bg-secondary-color": "##000000", 
  "nav-color": "#000000",
  "color-lightGrey": "#000000", 

  "color-primary": "#1ED760",
  "color-grey": "#1ED760",
  "color-1-min": "#1ED760", 

  "color-darkGrey": "#0E5D2A",

  "color-error": "#F230AA",
  "color-7-15-min": "#F230AA", 

  "color-success": "#1ED760",
  "color-6-min": "#1ED760",

  "color-7-min": "#E8E6CA",

  "font-color": "#ffffff",
};

const discord = {
  "bg-color": "#2F3136",
  "bg-secondary-color": "#202225",
  "nav-color": "#202225",
  "color-primary": "#5865F2",
  "color-lightGrey": "#202225",
  "color-grey": "#5865F2",
  "color-darkGrey": "#3BA3E8",
  "color-error": "#ED4245",
  "color-success": "#3AB8BA",
  "color-1-min": "#5865F2",
  "color-6-min": "#3AB8BA",
  "color-7-min": "#EB459E",
  "color-7-15-min": "#ED4245",
  "font-color": "#FFFFFF",
};

const moxfield = {
  "bg-color": "#222222",

  "bg-secondary-color": "#111111", 
  "nav-color": "#111111",
  "color-lightGrey": "#111111", 

  "color-primary": "#731FA1",
  "color-grey": "#731FA1",
  "color-1-min": "#731FA1", 

  "color-darkGrey": "#C999E6",
  "color-error": "#DC3545",
  "color-7-15-min": "#DC3545", 

  "color-success": "#198754",
  "color-6-min": "#198754",

  "color-7-min": "#3077FF",

  "font-color": "#FEFFFB",
};

const twitter = {
  "bg-color": "#22303c",

  "bg-secondary-color": "#15202b", 
  "nav-color": "#15202b",
  "color-lightGrey": "#15202b", 

  "color-primary": "#00aced",
  "color-grey": "#00aced",
  "color-1-min": "#00aced", 

  "color-darkGrey": "#C999E6",

  "color-error": "#C51F5D",
  "color-7-15-min": "#C51F5D", 

  "color-success": "#0CEDAE",
  "color-6-min": "#0CEDAE",

  "color-7-min": "#0076A1",

  "font-color": "#ffffff",
};

const whatsapp = {
  "bg-color": "#101d25",

  "bg-secondary-color": "#1c2d37", 
  "nav-color": "#1c2d37",
  "color-lightGrey": "#1c2d37", 

  "color-primary": "#00786c",
  "color-grey": "#00786c",
  "color-1-min": "#00786c", 

  "color-darkGrey": "#25d366",

  "color-error": "#ea1a42",
  "color-7-15-min": "#ea1a42", 

  "color-success": "#25d366",
  "color-6-min": "#25d366",

  "color-7-min": "#34b7f1",

  "font-color": "#ffffff",
};

const github = {
  "bg-color": "#0d1117",

  "bg-secondary-color": "#161b22", 
  "nav-color": "#161b22",
  "color-lightGrey": "#161b22", 

  "color-primary": "#529bf5",
  "color-grey": "#529bf5",
  "color-1-min": "#529bf5", 

  "color-error": "#f47068",
  "color-7-15-min": "#f47068", 

  "color-darkGrey": "#248636",
  "color-success": "#248636",
  "color-6-min": "#248636",

  "color-7-min": "#b083f0",

  "font-color": "#ffffff",
};

const youtube = {
  "bg-color": "#181818",

  "bg-secondary-color": "#202020", 
  "nav-color": "#202020",
  "color-lightGrey": "#202020", 

  "color-primary": "#ff0000",
  "color-grey": "#ff0000",
  "color-1-min": "#ff0000", 

  "color-error": "#ec407a",
  "color-7-15-min": "#ec407a", 

  "color-darkGrey": "#00887a",
  "color-success": "#00887a",
  "color-6-min": "#00887a",

  "color-7-min": "#0098a6",

  "font-color": "#ffffff",
};

export const themes = {
  "Nord": nord,
  "TokyoNight": tokyo,
  "Umbra": umbra,
  "OneDark": onedark,
  "Pastel": pastel,

  "Spotify": spotify,
  "Discord": discord,
  "Moxfield": moxfield,
  "Twitter": twitter,
  "Whatsapp": whatsapp,
  "GitHub": github,
  "YouTube": youtube,

  "": nord,
};




